import { Strings } from '@app/constants';
import { ProfileCard } from '@app/components/card';
import { IProjectDetails } from '../types';

interface Props {
  projectData: IProjectDetails;
}

export const ProjectInfo = ({ projectData }: Props) => {
  const managerNames = projectData?.project?.managers?.map((managerId: any) => {
    const manager = projectData?.users?.find((member: any) => member.id === managerId);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const managerName = `${manager?.firstName} ${manager?.lastName}`;
    return managerName;
  });

  const teamMemberNames = projectData?.project?.members?.map((memberId: any) => {
    const member = projectData?.users?.find((member: any) => member.id === memberId);
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const teamMemberName = `${member?.firstName} ${member?.lastName}`;
    return teamMemberName;
  });
  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
  const clientName = `${projectData?.project?.clients?.firstName} ${projectData?.project?.clients?.lastName}`;

  const fields = [
    Strings.field.projectName,
    Strings.field.client,
    Strings.field.manager,
    Strings.project.teamMembers,
    Strings.field.startDate,
    Strings.field.estimatedEndDate,
    Strings.field.priority,
    Strings.field.status,
  ];

  const data = [
    projectData?.project?.name ?? 'NA',
    clientName ?? 'NA',
    managerNames?.join(', ') ?? 'NA',
    teamMemberNames?.join(', ') ?? 'NA',
    projectData?.project?.startDate ?? 'NA',
    projectData?.project?.endDate ?? 'NA',
    projectData?.project?.priority ?? 'NA',
    projectData?.project?.status ?? 'NA',
  ];

  return (
    <ProfileCard
      fields={fields}
      data={data}
      title={Strings.field.projectInformation}
      iconImg="ic_projects"
      Src={projectData?.project?.image}
      desc={projectData?.project?.description}
    />
  );
};
